import { FormEvent, useState } from 'react';
import { useAuth } from '../state/AuthProvider';
import { Shell } from '../ui/PwaContent';

export function RegisterView() {
  const authContext = useAuth();
  const [message, setMessage] = useState<string>('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setLoading(true);
    setMessage('');
    setSuccess(false);

    const form = new FormData(event.currentTarget);

    try {
      const resultMessage = await authContext.register({
        username: String(form.get('username') ?? ''),
        real_name: String(form.get('real_name') ?? ''),
        email: String(form.get('email') ?? ''),
        telegram: String(form.get('telegram') ?? ''),
        password: String(form.get('password') ?? ''),
      });

      setMessage(resultMessage);
      setSuccess(true);
      event.currentTarget.reset();
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Registrierung fehlgeschlagen.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Shell title="Registrieren" subtitle="Beantrage ein Benutzerkonto. Ein Admin muss dich danach freischalten.">
      <form onSubmit={submit} className="grid max-w-2xl gap-4">
        <label className="wwpwa-label">Benutzername<input className="wwpwa-input" name="username" autoComplete="username" required /></label>
        <label className="wwpwa-label">Echter Name<input className="wwpwa-input" name="real_name" autoComplete="name" required /></label>
        <label className="wwpwa-label">E-Mail<input className="wwpwa-input" name="email" type="email" autoComplete="email" required /></label>
        <label className="wwpwa-label">Telegram optional<input className="wwpwa-input" name="telegram" placeholder="@benutzername" /></label>
        <label className="wwpwa-label">Passwort<input className="wwpwa-input" name="password" type="password" autoComplete="new-password" minLength={10} required /></label>

        <button className="wwpwa-button-primary" type="submit" disabled={loading}>
          {loading ? 'Wird gesendet ...' : 'Registrierung absenden'}
        </button>
      </form>

      {message && (
        <div className={success ? 'mt-4 rounded-xl border border-green-200 bg-green-50 p-3 text-green-900' : 'mt-4 rounded-xl border border-red-200 bg-red-50 p-3 text-red-900'}>
          {message}
        </div>
      )}
    </Shell>
  );
}
